/**
 * @fileoverview CSS module for the NativeDropdown component.
 * Contains styles for the dropdown menu, trigger button, label and container.
 *
 * @example
 * // Import and use in component
 * import css from './NativeDropdown.module.css'
 *
 * <div className={css.container}>
 *   <label className={css.label}>Select option</label>
 *   <div className={css.listbox}>
 *     <button className={css.trigger}>Click me</button>
 *   </div>
 * </div>
 */

.label {
    display: block;
    font-family: Inter;
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.017em;
    text-align: left;
    margin-bottom: 8px;
}

.container {
    position: relative;
    flex-direction: column;
    display: flex;
    width: auto;
}

.trigger {
    display: inline-flex;
    font-family: Inter;
    width: 100%;
    justify-content: space-between;
    border-radius: 0.75rem;
    border: 1px solid var(--neutural400);
    background-color: #fff;
    padding: 16px 12px;
    letter-spacing: -0.017em;
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    font-size: 18px;
    font-weight: 400;
    color: var(--neutural900);
    appearance: none;
}

.trigger:disabled {
    background-color: var(--neutural100);
    color: var(--neutural900);
    border-color: var(--neutural400);
}

.placeholder {
    color: var(--neutural500);
}

.error {
    outline: 6px solid var(--red300);
    border-color: var(--neutural900);
}

.errorMessage {
    margin-top: 1rem;
    margin-bottom: 1rem;
    color: var(--red700);
}

.chevron {
    position: absolute;
    top: 1rem;
    pointer-events: none;
    right: 1rem;
    height: 24px;
    width: 24px;
}
